//Style
import styles from "../../../../styles/Form-Inputs.module.css"

//primereact
import { TreeSelect } from "primereact/treeselect"
import { Skeleton } from "primereact/skeleton"

//Formik
import { useField } from "formik"

export default function RefTreeSelect({
  name,
  label,
  isInitialLoad,
  options,
  placeHolderValue,
  helpText,
  required,
  disabled,
}) {
  const [field, meta, helpers] = useField(name)

  function getSelect() {
    if (isInitialLoad) {
      return (
        <Skeleton
          className={meta.touched && meta.error ? "p-invalid block" : "block"}
          height="42px"
        />
      )
    } else {
      return (
        <>
          <TreeSelect
            options={options}
            value={field.value}
            onChange={(e) => {
              helpers.setValue(e.value)
            }}
            selectionMode="checkbox"
            className={meta.touched && meta.error ? "p-invalid" : undefined}
            placeholder={placeHolderValue}
            filter
            filterMode="strict"
            disabled={disabled}
          />
          {meta.touched && meta.error ? (
            <>
              <label id={`${name}-error`} className={styles.errFieldMsg}>
                {meta.error}
              </label>
              <br />
            </>
          ) : null}
        </>
      )
    }
  }

  return (
    <div className={styles.field}>
      <label>
        {label} {required ? <span style={{ color: "red" }}> * </span> : null}
        {helpText ? (
          <div>
            <small style={{ color: "gray" }}>{helpText}</small>
          </div>
        ) : null}
      </label>
      <div>{getSelect()}</div>
    </div>
  )
}
